import React from 'react'
import './PaymentCard.less'
import visaImg from '../../assets/images/newui/sellersignup/card-visa.svg'
import amexImg from '../../assets/images/newui/sellersignup/card-amex.svg'
import masterImg from '../../assets/images/newui/sellersignup/card-master.svg'
import discoverImg from '../../assets/images/newui/sellersignup/card-discover.svg'
import tickImg from '../../assets/images/newui/sellersignup/blue-tick.svg'

const PaymentCard = ({ isSelected, last4, exp_month, exp_year, brand }) => {
    const getCardImage = (type) => {
        switch (type) {
            case 'visa':
                return visaImg;
            case 'mastercard':
                return masterImg;
            case 'amex':
                return amexImg;
            case 'discover':
                return discoverImg;
            default:
                return;
        }
    }

    return <div className={`payment-card-container${isSelected ? ' selected' : ''}`}>
        {isSelected ? <img className='payment-card-tick' src={tickImg} /> : ''}
        <div className='payment-card-details'>
            <div className='payment-card-number' ><span>**** **** ****</span> <span>{last4}</span></div>
            <div className='payment-card-exp'><span>Exp:</span><span>{exp_month}/{exp_year}</span></div>
        </div>
        <div className='payment-card-brand'>
            <img src={getCardImage(brand)} />
        </div>
    </div>
}

export default PaymentCard;